<script setup lang="ts">
import CheckIcon from '@/assets/icons/CheckIcon.vue';
import DialogBanner from './DialogBanner.vue';
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

const props = withDefaults(
  defineProps<{
    completedAt: string | null;
    completedByName?: string | null;
  }>(),
  { completedByName: null },
);
const { completedAt, completedByName } = toRefs(props);

const { t, locale } = useI18n();

// "durch {name} am {date}, um {time}" — the completer part is omitted when unknown
const detailText = computed<string>(() => {
  const parts: string[] = [];
  if (completedByName.value) parts.push(t('reports.completedBy', { name: completedByName.value }));
  if (completedAt.value) {
    const date = new Date(completedAt.value);
    parts.push(
      t('reports.completedAt', {
        date: date.toLocaleDateString(locale.value, { day: 'numeric', month: 'long', year: 'numeric' }),
        time: date.toLocaleTimeString(locale.value, { hour: '2-digit', minute: '2-digit' }),
      }),
    );
  }
  return parts.join(' ');
});
</script>

<template>
  <DialogBanner variant="success">
    <template #icon>
      <CheckIcon class="size-icon-sm md:size-icon shrink-0" />
    </template>
    <div class="flex flex-col text-body md:flex-row">
      <span class="mr-1 font-semibold">{{ $t('reports.status.completed') }}</span>
      <span>{{ detailText }}</span>
    </div>
  </DialogBanner>
</template>
